import { render, staticRenderFns } from "./Notes.vue?vue&type=template&id=3c9066f0&scoped=true&"
import script from "./Notes.vue?vue&type=script&lang=js&"
export * from "./Notes.vue?vue&type=script&lang=js&"
import style0 from "./Notes.vue?vue&type=style&index=0&id=3c9066f0&lang=scss&scoped=true&"
import style1 from "./Notes.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9066f0",
  null
  
)

export default component.exports